import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Label, LabelSize, Input, InputType, InputTextAlign } from '@as/cotopaxi';
import { Box } from '@yonderland/andes-react';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { DELAY } from '../../../constants/GeneralConstants';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
const BASKET_QUANTITY_SELECTOR = 'basket-quantity';
const BasketQuantityField = ({ quantity, setQuantity }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const [value, setValue] = useState(quantity.toString());
    const enhanceValue = (val) => {
        let result = val;
        if (val === '0') {
            result = '1';
        }
        else if (val === '') {
            result = quantity.toString();
        }
        return Math.abs(parseInt(result, 10)).toString();
    };
    const handleChange = (event) => {
        setValue(event.target.value);
    };
    const handleBlur = (event) => {
        const { value: val } = event.target;
        const enhancedValue = enhanceValue(val);
        setValue(enhancedValue);
        setQuantity(parseInt(enhancedValue, 10));
    };
    useEffect(() => {
        const enhancedValue = enhanceValue(value);
        const timer = window.setTimeout(() => {
            setValue(enhancedValue);
            setQuantity(parseInt(enhancedValue, 10));
        }, DELAY.DELAY_2000);
        return () => window.clearTimeout(timer);
    }, [value]);
    return (_jsxs(_Fragment, { children: [_jsx(Label, { size: LabelSize.MINOR, emphasized: true, htmlFor: BASKET_QUANTITY_SELECTOR, children: t('pdp.quantity') }), _jsx(Box, { paddingBlock: "2", children: _jsx(Input, { type: InputType.NUMBER, textAlign: InputTextAlign.CENTER, name: BASKET_QUANTITY_SELECTOR, id: BASKET_QUANTITY_SELECTOR, onChange: handleChange, onBlur: handleBlur, value: value, min: 1 }) })] }));
};
export default BasketQuantityField;
